import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCreateFormAccessMutation } from '../../../../hooks/mutations/useFormAccessMutation';
import { FormTemplate } from '../../../../services/apiSLTP/qhse/forms/formTemplates';
import { capitalizeFirstLetter } from '../../../../utils/capitalize';
import DropDown, { OptionType } from '../../../ui/DropDown';
import ModalBody, { ModalProps } from '../../ModalBody';

interface AddGroupFormAccessModalProps extends ModalProps {
    refetch?: () => void;
    userId: string;
    userName: string;
    forms: FormTemplate[];
}

const AddGroupFormAccessModal: React.FC<AddGroupFormAccessModalProps> = ({ open, handleClose, refetch = () => {}, userId, userName, forms }) => {
    const { t } = useTranslation();

    const [selectedForm, setSelectedForm] = useState<OptionType | null>(null);

    const { mutate: createFormAccess } = useCreateFormAccessMutation({
        onSuccess: () => {
            refetch();
        },
    });

    return (
        <ModalBody
            title={t('form')}
            subtitle={t('createCopy')}
            description={userName}
            open={open}
            handleClose={handleClose}
            onSubmit={() => {
                createFormAccess({ groupId: selectedForm?.value || '', userId });
            }}
            disableSubmit={!selectedForm}
        >
            <DropDown
                items={forms.filter((form) => !form.isPublic).map((form) => ({ label: form.title, value: form.groupId }))}
                inputLabel={capitalizeFirstLetter(t('form'))}
                selectedItem={selectedForm}
                handleChange={(e, value) => setSelectedForm(value)}
                required
            />
        </ModalBody>
    );
};

export default AddGroupFormAccessModal;
